import { render, staticRenderFns } from "./myCourse.vue?vue&type=template&id=68654f77&scoped=true"
import script from "./myCourse.vue?vue&type=script&lang=js"
export * from "./myCourse.vue?vue&type=script&lang=js"
import style0 from "./myCourse.vue?vue&type=style&index=0&id=68654f77&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68654f77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68654f77')) {
      api.createRecord('68654f77', component.options)
    } else {
      api.reload('68654f77', component.options)
    }
    module.hot.accept("./myCourse.vue?vue&type=template&id=68654f77&scoped=true", function () {
      api.rerender('68654f77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/keeCourses/myCourse.vue"
export default component.exports